import * as React from 'react';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IFollowerDto, IAuthContext } from 'models/common';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import renderIcon from 'helpers/renderIcon';
import ShowOptions, { IShowOptionsProps } from 'components/ContextMenus/ShowOptions';
const { connect } = require('react-redux');
import { changeTabAndGetRequiredData, unfollowItem } from 'modules/user/usercard';
import { IStore } from 'redux/IStore';
import { IUserCardAction, IUserCardData } from 'models/user/usercard';
import { changeTabAndGetRequiredDataFunction } from 'containers/User/Helpers';
import { idFromEntityId, imgSrcAttributes } from 'helpers/common';

interface IProps extends IItemCardProps {
	follwersComponent?: boolean;

	item: IFollowerDto;
	followItem?: (itemType: string, itemId: string) => void;
	unfollowItem: (id: string, type: string, isUserCardFollowButton: boolean) => IUserCardAction;
	t?: (key: string, options?: any) => string;
	context?: IAuthContext;

	userCardData?: IUserCardData;
	changeTabAndGetRequiredData: (selectedTab: string, userId: string) => IUserCardAction;
}

interface IState {
	optionsOpen: boolean;
}

@connect(
	(state: IStore) => ({
		userCardData: state.usercard,
	}),
	(dispatch) => ({
		changeTabAndGetRequiredData: (selectedTab: string, userId: string) =>
			dispatch(changeTabAndGetRequiredData(selectedTab, userId)),
		unfollowItem: (id: string, type: string, isUserCardFollowButton: boolean) =>
			dispatch(unfollowItem(id, type, isUserCardFollowButton, true)),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class FollowerFollowingItemCardComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.followUser = this.followUser.bind(this);
		this.unfollowUser = this.unfollowUser.bind(this);
		this.goToCard = this.goToCard.bind(this);
		this.handleOptionsOpen = this.handleOptionsOpen.bind(this);
		this.handleOptionsClose = this.handleOptionsClose.bind(this);
		this.visitProfile = this.visitProfile.bind(this);

		this.state = {
			optionsOpen: false,
		};
	}

	private goToCard(e: any) {
		e.preventDefault();
		if (this.props.goToCard) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.goToCard(entityIdObj.id, entityIdObj.type);
		}
	}

	public followUser() {
		const entityIdObj: any = JSON.parse(this.props.item.entityId);
		this.props.followItem(entityIdObj.type, entityIdObj.id);
	}

	public unfollowUser() {
		const entityIdObj: any = JSON.parse(this.props.item.entityId);
		this.props.unfollowItem(entityIdObj.id, entityIdObj.type, false);
		this.handleOptionsClose();
	}

	public handleOptionsOpen() {
		this.setState({
			optionsOpen: true,
		});
	}
	public handleOptionsClose() {
		this.setState({
			optionsOpen: false,
		});
	}

	public visitProfile(x: { id: string; type: string }) {
		if (x) {
			this.props.goToCard(x.id, x.type);
			changeTabAndGetRequiredDataFunction(
				null,
				c.USERCARD_TAB_OVERVIEW,
				this.props.userCardData?.usercard?.id,
				this.props.changeTabAndGetRequiredData,
			);
		}
	}

	public render() {
		const { t, userCardData } = this.props;
		const { optionsOpen } = this.state;
		const { picture, name, entityId } = this.props.item;
		const userId = idFromEntityId(entityId);

		const options: IShowOptionsProps['options'] = (
			userCardData.selectedTab === c.USERCARD_TAB_FOLLOWING
				? [
						{
							text: t('PortalPage_SectionItems_SectionItemProfile_Button_ViewProfile'),
							action: () => this.visitProfile(JSON.parse(entityId)),
						},
						this.props.currentUserId === userId
							? null
							: {
									text: t('BSPortal_Common_Unfollow'),
									action: () => this.unfollowUser(),
							  },
				  ]
				: [
						{
							text: t('PortalPage_SectionItems_SectionItemProfile_Button_ViewProfile'),
							action: () => this.visitProfile(JSON.parse(entityId)),
						},
				  ]
		).filter(Boolean);

		return (
			<div className="col-sm-12 col-md-5 followerFollowingItemCard d-flex flex-row align-items-center">
				<div className="imageLink">
					<a href="#" onClick={this.goToCard}>
						{picture ? (
							<img {...imgSrcAttributes(picture)} />
						) : (
							<div className="image-container">{renderIcon('pfp_default')}</div>
						)}{' '}
					</a>
				</div>
				<div className="title">
					<p className="p16">{name}</p>
				</div>
				<div className="icon-container pointer" onClick={this.handleOptionsOpen}>
					{renderIcon('more', 22, 10)}
				</div>
				<ShowOptions options={options} isOpen={optionsOpen} closeOptions={this.handleOptionsClose} />
			</div>
		);
	}
}

const FollowerFollowingItemCard = withAuthContext(FollowerFollowingItemCardComponent);
export { FollowerFollowingItemCard };
